import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { TenantSettingsApi } from '../api/tenant-settings.api';
import * as fromTenantSettings from './tenant-settings.reducer';
import { TenantSettingsEffects } from './tenant-settings.effects';

@NgModule({
    imports: [
        StoreModule.forFeature(fromTenantSettings.tenantSettingsFeature),
        EffectsModule.forFeature([TenantSettingsEffects]),
    ],
    providers: [TenantSettingsApi],
})
export class TenantSettingsDataAccessModule {}
